import styled from "styled-components";

import "../../../../GlobalStyles/Font.css";

export const FooterSection = styled.footer`
  margin-top: 89px;

  @media (min-width: 428px) {
    margin-top: 47px;
  }

  @media (min-width: 744px) {
    margin-top: 67px;
  }

  @media (min-width: 1024px) {
    margin-top: 76px;
  }

  @media (min-width: 1440px) {
    margin-top: 60px;
  }
`;

export const FooterContainer = styled.div`
  background: #1ac63f;
`;

export const FooterContainerDescribeInfo = styled.div`
  max-width: 100%;
  padding: 106px 0 106px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media (min-width: 744px) {
    padding: 16px 24px;
    flex-direction: row;
    justify-content: space-between;
    max-width: 712px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 1024px) {
    max-width: 976px;
    padding: 22px 24px;
  }

  @media (min-width: 1440px) {
    max-width: 1392px;
    padding: 24px 31px;
  }
`;

export const FooterTitle = styled.a`
  font-size: 20px;
  font-family: "Exo2 Medium";
  line-height: 1.2;
  color: #fff;

  @media (min-width: 1440px) {
    font-size: 36px;
    line-height: 1.19;
  }
`;

export const FooterDescribeText = styled.p`
  font-size: 20px;
  font-family: "Exo2 Medium";
  line-height: 1.2;
  color: #fff;

  @media (min-width: 1440px) {
    font-size: 36px;
    line-height: 1.19;
  }
`;
